import { Button, Col, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DispatcherMap } from "../../map/Map";
import { RootState } from "../../../app/store";
import UserRequestForm from "./form";
import ContainerLayout from "../../common/containerLayout";
import { WebRoutes } from "../../../shared/constants/WebRoutes";
import { resetTrip } from "../../../features/map/mapSlice";
import UserRequestDTO from "../../../shared/dtos/userRequestDTO";
import ScheduleType from "../../../shared/enum/ScheduleTypeEnum";
import { userRequestPostAsync } from "../../../features/userRequest/userRequestPostSlice";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import "./form/styles.css";

export default function CreateUserRequest() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const { destinations } = useAppSelector((state: RootState) => state?.map);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(resetTrip());
  }, [dispatch]);

  const scheduleType: number = Form.useWatch("scheduleType", form);

  const handleRequestTrip = async (userRequest: UserRequestDTO) => {
    try {
      if (scheduleType === ScheduleType.ROUND) {
        await dispatch(userRequestPostAsync(userRequest)).unwrap();
        userRequest.scheduleAt = dayjs(form.getFieldValue("roundDate")).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        userRequest.isRoundTrip = true;
      }

      await dispatch(userRequestPostAsync(userRequest)).unwrap();
      navigate(WebRoutes.TripListRoute, {
        replace: true,
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContainerLayout showNotification={false} title="Detalles del viaje">
      <Col span={10}>
        <Row gutter={[32, 12]}>
          <Col span={24} className="create-container">
            <UserRequestForm
              form={form}
              setLoading={setLoading}
              handleRequestTrip={handleRequestTrip}
            />
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={16}>
              <Col>
                <Button
                  form="trip"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Solicitar
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() =>
                    navigate(WebRoutes.TripListRoute, { replace: true })
                  }
                  disabled={loading}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={14}>
        <DispatcherMap
          destinations={destinations}
          shouldCalculateDistance={true}
          height="87vh"
        />
      </Col>
    </ContainerLayout>
  );
}
